import { CurrencyUtils } from './currencyUtils';

export class AmountUtils {
  static transformToAmountWithCurrency = (amount: number | null | undefined, currency?: string | null) => {
    if (typeof amount !== 'number' || isNaN(amount)) return '';
    const symbol = currency ? CurrencyUtils.getSymbolByCode(currency) : '';
    return `${symbol} ${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`.trim();
  };
}
